import urlPrefix from "./apiPrefix";

export const postClientTaxpayersByLocations = () => `${urlPrefix.value}/tax-web-control/client/api/taxpayers/byLocations`;
export const getClientTicket = () => `${urlPrefix.value}/tax-web-control/client/api/v1/ticket`;
export const getClientTaxpayersPreRegisterInfo = (tin: string) => `${urlPrefix.value}/tax-web-control/client/api/taxpayers/preregister-info/${tin}`;
export const getClientLocationsByName = () => `${urlPrefix.value}/tax-web-control/client/api/locations/byName`;
export const getClientClustersByName = () => `${urlPrefix.value}/tax-web-control/client/api/clusters/byName`;
